import { getMySubmissions } from "../api/submissions";
import { getMyWarps } from "../api/warps";
import { getMyListings } from "../api/realestate";

export const SUBMISSION_TYPE_LABELS = {
  SCREENSHOT: "Screenshot",
  BLOG: "Blog post",
  WARP: "Player warp",
  REAL_ESTATE: "Real estate",
};

export function normalizeScreenshotOrBlog(item) {
  const blogPostId = item.blog?.postId;
  const canEditBlog =
    item.submissionType === "BLOG" &&
    blogPostId &&
    (item.status === "DRAFT" || item.status === "PENDING");

  return {
    ...item,
    key:
      item.status === "DRAFT" && item.submissionType === "BLOG"
        ? `blog-draft-${blogPostId || item.id}`
        : `submission-${item.id}`,
    editUrl: canEditBlog ? `/submissions/blog/${blogPostId}` : null,
  };
}

export function normalizeWarp(warp) {
  const firstImage = warp.images?.[0];
  const imagePath = firstImage?.thumbnailPath || firstImage?.originalPath;

  return {
    key: `warp-${warp.id}`,
    id: warp.id,
    submissionType: "WARP",
    status: warp.isPublished ? "APPROVED" : "PENDING",
    title: warp.name,
    thumbnailUrl: imagePath ? `/uploads/warps/${imagePath}` : null,
    createdAt: warp.createdAt,
    warp: {
      id: warp.id,
      playerWarpId: warp.playerWarpId,
      name: warp.name,
      description: warp.description,
      types: warp.types,
    },
    viewUrl: warp.isPublished ? `/warps/${warp.id}` : null,
    editUrl: `/warps/${warp.id}/edit`,
  };
}

export function normalizeRealEstate(listing) {
  const firstImage = listing.images?.[0];
  const imagePath = firstImage?.thumbnailPath || firstImage?.originalPath;

  return {
    key: `realestate-${listing.id}`,
    id: listing.id,
    submissionType: "REAL_ESTATE",
    status: listing.isPublished ? "APPROVED" : "PENDING",
    title: listing.title,
    thumbnailUrl: imagePath ? `/uploads/realestate/${imagePath}` : null,
    createdAt: listing.createdAt,
    realEstate: {
      id: listing.id,
      listingType: listing.listingType,
      listingStatus: listing.status,
    },
    viewUrl: listing.isPublished ? `/real-estate/${listing.id}` : null,
    editUrl: `/real-estate/${listing.id}/edit`,
  };
}

export function mergeMySubmissions({ submissions = [], warps = [], listings = [] }) {
  const merged = [
    ...submissions.map(normalizeScreenshotOrBlog),
    ...warps.map(normalizeWarp),
    ...listings.map(normalizeRealEstate),
  ];

  merged.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  return merged;
}

function emptyWarpsOnForbidden(err) {
  if (err?.status === 403) return { warps: [] };
  throw err;
}

function emptyListingsOnForbidden(err) {
  if (err?.status === 403) return { listings: [] };
  throw err;
}

export async function fetchAllMySubmissions() {
  const subsRes = await getMySubmissions();
  const warpsRes = await getMyWarps().catch(emptyWarpsOnForbidden);
  const listingsRes = await getMyListings().catch(emptyListingsOnForbidden);

  return mergeMySubmissions({
    submissions: subsRes.submissions || [],
    warps: warpsRes.warps || [],
    listings: listingsRes.listings || [],
  });
}
